import { render, staticRenderFns } from "./CustomerCodeSelect.vue?vue&type=template&id=047c57ce&scoped=true"
import script from "./CustomerCodeSelect.vue?vue&type=script&lang=ts"
export * from "./CustomerCodeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c57ce",
  null
  
)

export default component.exports